import React, { useRef } from "react";
import { inpS, btnSec } from "../../constants/styles";

const PhotoUpload = ({ label, value, onChange, h }) => {
  const inputRef = useRef(null);
  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const MAX = 800;
        let w = img.width, ht = img.height;
        if (w > ht) { if (w > MAX) { ht *= MAX / w; w = MAX; } } else { if (ht > MAX) { w *= MAX / ht; ht = MAX; } }
        canvas.width = w; canvas.height = ht;
        canvas.getContext('2d').drawImage(img, 0, 0, w, ht);
        onChange(canvas.toDataURL('image/jpeg', 0.6));
      };
      img.src = ev.target.result;
    };
    reader.readAsDataURL(file);
  };
  return <div style={{ marginBottom: 12 }}>
    <label style={{ color: h.sc, fontSize: 13, fontWeight: 500, display: "block", marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.5 }}>{label}</label>
    {value ? <div><img src={value} alt={label} style={{ width: "100%", borderRadius: 10, marginBottom: 8 }} /><button onClick={() => onChange(null)} style={{ ...btnSec(h), marginTop: 0, fontSize: 12 }}>{"✕ " + label}</button></div>
    : <button onClick={() => inputRef.current.click()} style={btnSec(h)}>{"📷 " + label}</button>}
    <input ref={inputRef} type="file" accept="image/*" capture="environment" style={{ display: "none" }} onChange={handleFile} />
  </div>;
};

export default PhotoUpload;
